@if(startcart | async;  as item){
<section class="col-xs-12 cart_titlesection cartsectionuk">
    <div class="col-xs-12 col-md-8 mycartsection">
        <div class="cart_header">{{item.headline}}</div>
        <div class="cart_subheader"></div>
    </div>
@if(enablePage.showLocationPage || enablePage.showProductPage || enablePage.showReviewPage || enablePage.showSorryPage || enablePage.showSaveThankYouPage || enablePage.showConfirmThankYouPage || enablePage.showinseasonConfirmThankYouPage || enablePage.showAmendProductPage || enablePage.showAmendReviewPage || enablePage.showAmendThankYouPage){
    <div class="cart_dateheader normalflowtext" [innerHtml]="item.content" ></div>
    <div class="cart_dateheader inseasonflowtext" [innerHtml]="item.largeparagraphcontent" ></div>
}
</section>
}
